var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCentral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.7921 31.1353H87.7681V64.8457H90.7921V31.1353Z",
    fill: "#88919E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6969 31.1353H46.6729V64.8457H49.6969V31.1353Z",
    fill: "#88919E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7735 31.1353H16.7495V64.8457H19.7735V31.1353Z",
    fill: "#88919E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4239 31.1353H2.3999V64.8457H5.4239V31.1353Z",
    fill: "#88919E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0808 31.1353H63.3096H61.3272H59.3256H58.3032V64.8457H61.3272V34.1593H63.3096V48.5113H61.9992V64.8649H64.9488V48.5113H66.3336V31.1353H65.0808Z",
    fill: "#88919E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0417 31.1353H35.1841H32.8009H31.2889H29.7769V64.8457H32.8009V34.1593H35.1841V64.8457H38.2081V31.1353H37.0417Z",
    fill: "#88919E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.188 31.1353H77.676H75.4608H73.4352H72.4392V64.8457H75.4608V34.1593H77.676V64.8457H80.7V31.1353H79.188Z",
    fill: "#88919E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9672 31.1353H50.4456V33.1849H51.9672V31.1353Z",
    fill: "#88919E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9239 31.1353H44.4023V33.1849H45.9239V31.1353Z",
    fill: "#88919E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0897 31.1353H20.5681V33.1849H22.0897V31.1353Z",
    fill: "#88919E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0897 46.9705H20.5681V49.0201H22.0897V46.9705Z",
    fill: "#88919E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0897 62.796H20.5681V64.8456H22.0897V62.796Z",
    fill: "#88919E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76647 62.796H6.24487V64.8456H7.76647V62.796Z",
    fill: "#88919E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76647 31.1353H6.24487V33.1849H7.76647V31.1353Z",
    fill: "#88919E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3737 46.464H75.8521V48.5136H77.3737V46.464Z",
    fill: "#88919E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6001 62.8152H91.4785V64.8648H93.6001V62.8152Z",
    fill: "#88919E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentral);
export default __webpack_public_path__ + "static/media/CENTRAL.ecc7be9d2dbda3f4761c1dcda8446b82.svg";
export { ForwardRef as ReactComponent };